import React from "react";
import { __ } from "@wordpress/i18n";
import { useLocation, Link } from "react-router-dom";
import MegaMenu from "../../layouts/MegaMenu/MegaMenu";

// Import all the pages
import GlobalSettings from "../global-settings/GlobalSettings";
import ColorCustomizer from "../color-customizer/ColorCustomizer";
import Permission from "../permission/Permission";
import Reset from "../reset/Reset";
import OtherPlugin from "../other-plugins";
import UserRoleEditor from "../user-role-editor";
import Extra from "../extra";
import RoleManager from "../role-manager";
import BackupRestoreRole from "../backup-restore-role"

const Settings = () => {
  const location = useLocation();
  const pathname = location.pathname;
  

  const ROUTE_COMPONENT_MAP = {
    // User Role Editor pages
    "/roles/edit-role-capabilities": UserRoleEditor,
    "/roles/role-manager": RoleManager,
    "/roles/backup-and-restore": BackupRestoreRole,
    
    // Global Settings pages
    "/settings/settings": GlobalSettings,
    "/settings/color-customizer": ColorCustomizer,
    "/settings/permission": Permission,
    
    // More pages
    "/more/reset": Reset,
    "/more/extra": Extra,
    
    // Other plugins
    "/other-plugin": OtherPlugin,
  };
  
  const renderContent = () => {
    // Look up the component for the current path
    const Component = ROUTE_COMPONENT_MAP[pathname];
    
    // If a component is found, render it, otherwise show SettingsNotFound
    return Component ? <Component /> : <SettingsNotFound />;
  };

  return (
    <>
      <div className="row">
        <div className="col-3" style={{width: "20%"}}>
          <MegaMenu />
        </div>
        <div className="col-9" style={{width: "80%"}}>
          {renderContent()}
        </div>
      </div>
    </>
  );
};

// Not found component for settings
const SettingsNotFound = () => (
  <div>
    <h2>{__("Setting Not Found", "access-control")}</h2>
    <p>{__("The setting you are looking for does not exist.", "access-control")}</p>
    <Link to="/settings">{__("Go back to Settings", "access-control")}</Link>
  </div>
);

export default Settings;